import { useEffect } from 'react';

const useEnterKey = <T extends HTMLElement>(callback: () => void, elementRef: React.RefObject<T>): void => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Enter') {
                callback();
            }
        };

        const element = elementRef.current;

        if (element) {
            element.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            if (element) {
                element.removeEventListener('keydown', handleKeyDown);
            }
        };
    }, [callback, elementRef]);
};

export default useEnterKey;
